import styled from 'styled-components';

export const ALink = styled.a`
    font-weight: 700;
    color: ${(props) => {
        if (props.$delete) {
            return props.theme.deleteText;
        } else if (props.$secondary) {
            return props.theme.accent;
        } else {
            return props.theme.primary;
        }
    }};

    text-decoration: none;
    &:hover {
        color: ${(props) => {
            if (props.$delete) {
                return props.theme.primary;
            } else {
                return props.theme.primary;
            }
        }};
    }
    cursor: pointer;
`;

export const PassedLink = styled.p`
    a {
        font-weight: 700;
        color: ${(props) => {
            if (props.$delete) {
                return props.theme.deleteText;
            } else if (props.$secondary) {
                return props.theme.accent;
            } else {
                return props.theme.primary;
            }
        }};

        text-decoration: none;
        &:hover {
            color: ${(props) => {
                if (props.$delete) {
                    return props.theme.primary;
                } else {
                    return props.theme.primary;
                }
            }};
        }
        cursor: pointer;
    }
`;
